import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '../../front/Plans/Card';
import { Context, anaBlue, anaBackgroundColor } from './Ana';
import Title from './Title';
import { Flight as FlightIcon } from '@material-ui/icons';
import japanMap from '../../../images/features/ana/japan_map.png';
import { styles as containerStyles } from '../styles/container';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: anaBackgroundColor,
  },
  wrapper: {
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    margin: 'auto',
    ...containerStyles(theme),
  },
  containerMap: {
    display: 'flex',
    justifyContent: 'center',
    margin: '40px 0',
  },
  mapImg: {
    maxWidth: '600px',
    maxHeight: '450px',
    width: '100%',
    height: 'auto',
  },
  badge: {
    position: 'absolute',
    left: -150,
    backgroundColor: anaBlue,
    width: 150,
    height: 150,
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeInner: {
    borderRadius: '50%',
    border: 'solid thin white',
    width: 140,
    height: 140,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 15,
    fontWeight: 'bold',
  },
  hagiIwami: {
    position: 'absolute',
    top: 150,
    left: 0,
    zIndex: 10,
  },
  placeTitle: {
    marginBottom: 8,
    fontWeight: 'bold',
  },
  placeAirport: {
    color: anaBlue,
    fontSize: 18,
    border: `1px solid #03286F`,
    borderRadius: 5,
    backgroundColor: 'white',
    fontWeight: 'bold',
    padding: '10px 28px',
  },
  airportTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: -4,

    marginTop: 20,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
  flightIcon: {
    color: anaBlue,
    marginRight: 8,
  },
  airportName: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(18),
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(24),
      margin: theme.spacing(0),
    },
  },
  planContainer: {
    paddingTop: theme.spacing(2.5),
  },
  iwamiBorderBox: {
    position: 'absolute',
    left: 65,
    width: 83,
    bottom: 117,
    height: 80,
    borderLeft: `1px solid ${anaBlue}`,
    borderBottom: `1px solid ${anaBlue}`,
  },
}));

const Plan = ({ isAuthenticated }) => {
  const classes = useStyles();
  const { plans } = React.useContext(Context);
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Title texts={['コラボ連携している空港＆', 'おてつたび先']} />
        <div className={classes.containerMap}>
          <img src={japanMap} alt="日本地図" className={classes.mapImg} />
        </div>
        {plans.length > 0 && (
          <>
            <Title texts={['現在募集中のおてつたび']} />
            <h3 className={classes.airportTitle}>
              <FlightIcon className={classes.flightIcon} />
              <span className={classes.airportName}>米子空港 / 鳥取空港</span>
            </h3>
            <Grid container spacing={2} className={classes.planContainer}>
              {plans.map((plan, index) => (
                <Grid item xs={6} sm={3} key={`ana-plan${index}`}>
                  <Card {...plan} isAuthenticated={isAuthenticated} />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </div>
    </div>
  );
};

export default Plan;
